<template>
  <section class="articles-container">
    <div class="content-max-width flex align-stretch">
      <article v-for="project in shownProjects" :key="project.id">
        <a :href="project.slug" class="image">
          <picture>
            <source media="(min-width: 650px)" :srcset="project.image">
            <source :srcset="project.image">
            <img :src="project.image" alt="">
          </picture>
        </a>
        <div class="content">
          <p class="date">{{project.date}}</p>
          <h3>
              <a :href="project.slug">
              {{project.title}}
            </a>
          </h3>
        </div>
      </article>
    </div>


    <div v-if="canLoadMore" class="content-max-width flex load-area">
      <button class="button orange-border" @click="page++">LOAD MORE</button>
    </div>

  </section>
</template>

<script>
export default {
  props: {
    projects: {
      type: Array,
      required: true,
    },
  },

  data () {
    return {
      loadedMore: false,
      page: 1,
      numPerPage: window.innerWidth <= 1024 ? 8 : 9
    }
  },

  computed: {
    shownProjects () {
      return this.projects.slice(0, this.numProjectsToShow)
    },

    numProjectsToShow () {
      return this.numPerPage * this.page
    },

    canLoadMore () {
      return this.projects.length > this.numProjectsToShow
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ProjectList.vue